package ui.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import org.w3c.dom.HTMLInputElement
import ui.theme.ThemeMode

@Composable
fun AddActionModal(
    onSave: (String, String, String, String) -> Unit,
    onCancel: () -> Unit
) {
    var title by remember { mutableStateOf("") }
    var description by remember { mutableStateOf("") }
    var url by remember { mutableStateOf("") }
    var icon by remember { mutableStateOf("🚀") }
    
    // Modal overlay
    Div({
        classes("modal-overlay")
        onClick { onCancel() }
    }) {
        // Modal content
        Div({
            classes("modal-content", "add-action-modal", "theme-style")
            onClick { event -> event.stopPropagation() }
        }) {
            // Header
            H2({
                classes("modal-title")
            }) {
                Text("Add New Action")
            }
            
            // Form fields
            Div({
                classes("form-group")
            }) {
                Label {
                    Text("Title")
                }
                Input(InputType.Text) {
                    classes("form-input")
                    placeholder("Enter action title")
                    value(title)
                    onInput { event -> 
                        title = (event.target as HTMLInputElement).value
                    }
                }
            }
            
            Div({
                classes("form-group")
            }) {
                Label {
                    Text("Description")
                }
                Input(InputType.Text) {
                    classes("form-input")
                    placeholder("Enter description")
                    value(description)
                    onInput { event -> 
                        description = (event.target as HTMLInputElement).value
                    }
                }
            }
            
            Div({
                classes("form-group")
            }) {
                Label {
                    Text("URL")
                }
                Input(InputType.Url) {
                    classes("form-input")
                    placeholder("https://example.com")
                    value(url)
                    onInput { event -> 
                        url = (event.target as HTMLInputElement).value
                    }
                }
            }
            
            Div({
                classes("form-group")
            }) {
                Label {
                    Text("Icon (emoji)")
                }
                Input(InputType.Text) {
                    classes("form-input")
                    placeholder("🚀")
                    value(icon)
                    onInput { event -> 
                        icon = (event.target as HTMLInputElement).value
                    }
                }
            }
            
            // Buttons
            Div({
                classes("modal-buttons")
            }) {
                Button({
                    classes("btn", "btn-secondary")
                    onClick { onCancel() }
                }) {
                    Text("Cancel")
                }
                
                Button({
                    classes("btn", "btn-primary")
                    onClick { 
                        if (title.isNotBlank() && url.isNotBlank()) {
                            onSave(title, description, url, icon)
                        }
                    }
                }) {
                    Text("Add Action")
                }
            }
        }
    }
}

@Composable
fun ThemeToggleModal(
    currentTheme: ThemeMode,
    onThemeChange: (ThemeMode) -> Unit,
    onClose: () -> Unit
) {
    // Modal overlay
    Div({
        classes("modal-overlay")
        onClick { onClose() }
    }) {
        // Modal content
        Div({
            classes("modal-content", "theme-dialog")
            onClick { event -> event.stopPropagation() }
        }) {
            H2({
                classes("modal-title")
            }) {
                Text("Choose Theme")
            }
            
            // Theme options
            Div({
                classes("theme-options")
            }) {
                // Light theme option
                Div({
                    val classNames = buildList {
                        add("theme-option")
                        if (currentTheme == ThemeMode.LIGHT) add("selected")
                    }
                    classes(*classNames.toTypedArray())
                    onClick { 
                        onThemeChange(ThemeMode.LIGHT)
                    }
                }) {
                    Text("Light")
                }
                
                // Dark theme option
                Div({
                    val classNames = buildList {
                        add("theme-option")
                        if (currentTheme == ThemeMode.DARK) add("selected")
                    }
                    classes(*classNames.toTypedArray())
                    onClick { 
                        onThemeChange(ThemeMode.DARK)
                    }
                }) {
                    Text("Dark")
                }
                
                // Auto theme option
                Div({
                    val classNames = buildList {
                        add("theme-option")
                        if (currentTheme == ThemeMode.AUTO) add("selected")
                    }
                    classes(*classNames.toTypedArray())
                    onClick { 
                        onThemeChange(ThemeMode.AUTO)
                    }
                }) {
                    Text("Auto")
                }
            }
            
            // Done button
            Div({
                classes("theme-dialog-actions")
            }) {
                Button({
                    classes("theme-done-button")
                    onClick { onClose() }
                }) {
                    Text("Done")
                }
            }
        }
    }
}
